import { Injectable } from '@angular/core';
import { BizComponentEntity } from '../../domain/entities/biz-component.entity';
import { ActualParameter } from '../../domain/entities/actual-parameter';
import { WfLocalePipe } from '../../i18n/pipe/wf-process-editor-locale.pipe';

@Injectable()

export class ActivityComponentUIState {
    constructor(
        private localePipe: WfLocalePipe
    ) { }
    /**
     * 构件列表
     */
    components: BizComponentEntity[] = [];
    /**
     * 选中构件
     */
    curComponent: BizComponentEntity;
    /**
     * 流程分类绑定的所有活动构件
     */
    allComponents: BizComponentEntity[] = [];
    /**
     * 构件执行时机数据绑定
     */
    public executionCollection = [
        // { text: '流程创建', value: 'PROCESSINSTANCE_CREATED' },
        { text: this.localePipe.transform("component.activityComponent.PROCESSINSTANCE_STARTED"), value: 'PROCESSINSTANCE_STARTED' },
        { text: this.localePipe.transform("component.activityComponent.PROCESSINSTANCE_SUSPENDED"), value: 'PROCESSINSTANCE_SUSPENDED' },
        { text: this.localePipe.transform("component.activityComponent.PROCESSINSTANCE_RESUMED"), value: 'PROCESSINSTANCE_RESUMED' },
        { text: this.localePipe.transform("component.activityComponent.PROCESSINSTANCE_COMPLETED"), value: 'PROCESSINSTANCE_COMPLETED' },
        { text: this.localePipe.transform("component.activityComponent.PROCESSINSTANCE_ABORTED"), value: 'PROCESSINSTANCE_ABORTED' },
        // { text: '流程预警', value: 'PROCESSINSTANCE_ALARM' },
        // { text: '流程超时', value: 'PROCESSINSTANCE_TIMEOUT' },
        // { text: '流程删除', value: 'PROCESSINSTANCE_DELETED' },
        { text: this.localePipe.transform("component.activityComponent.PROCESSINSTANCE_CANCELED"), value: 'PROCESSINSTANCE_CANCELED' },
        { text: this.localePipe.transform("component.activityComponent.PROCESSINSTANCE_REACTIVATED"), value: 'PROCESSINSTANCE_REACTIVATED' },
        { text: this.localePipe.transform("component.activityComponent.PROCESSINSTANCE_ROLLBACK"), value: 'PROCESSINSTANCE_ROLLBACK' },
        { text: this.localePipe.transform("component.activityComponent.PROCESSINSTANCE_RESUBMIT"), value: 'PROCESSINSTANCE_RESUBMIT' },
        { text: this.localePipe.transform("component.activityComponent.ACTIVITY_AND_PARTICIPANT_UPDATED"), value: 'ACTIVITY_AND_PARTICIPANT_UPDATED' },
        { text: this.localePipe.transform("component.activityComponent.PROCESSINSTANCE_ABORTED_BY_ADMIN"), value: 'PROCESSINSTANCE_ABORTED_BY_ADMIN' },
        { text: this.localePipe.transform("component.activityComponent.PROCESSINSTANCE_BEFORE_START"), value: 'PROCESSINSTANCE_BEFORE_START' },
        { text: this.localePipe.transform("component.activityComponent.WORKITEM_BEFORE_COMPLETE"), value: 'WORKITEM_BEFORE_COMPLETE' },
        { text: this.localePipe.transform("component.activityComponent.WORKITEM_AFTER_COMPLETE"), value: 'WORKITEM_AFTER_COMPLETE' },
        { text: this.localePipe.transform("component.activityComponent.LOADDATA"), value: 'LOADDATA' }
    ];
    activityCollection = [
        // { text: '活动创建', value: 'ACTIVITY_CREATED' },
        { text: this.localePipe.transform("component.activityComponent.ACTIVITY_STARTED"), value: 'ACTIVITY_STARTED' },
        // { text: '活动挂起', value: 'ACTIVITY_SUSPENDED' },
        // { text: '活动恢复', value: 'ACTIVITY_RESUMED' },
        { text: this.localePipe.transform("component.activityComponent.ACTIVITY_COMPLETED"), value: 'ACTIVITY_COMPLETED' },
        { text: this.localePipe.transform("component.activityComponent.ACTIVITY_ABORTED"), value: 'ACTIVITY_ABORTED' },
        { text: this.localePipe.transform("component.activityComponent.WORKITEM_CREATED"), value: 'WORKITEM_CREATED' },
        { text: this.localePipe.transform("component.activityComponent.WORKITEM_COMPLETED"), value: 'WORKITEM_COMPLETED' },
        { text: this.localePipe.transform("component.activityComponent.WORKITEM_SUSPENDED"), value: 'WORKITEM_SUSPENDED' },
        { text: this.localePipe.transform("component.activityComponent.WORKITEM_RESUMED"), value: 'WORKITEM_RESUMED' },
        { text: this.localePipe.transform("component.activityComponent.WORKITEM_ABORTED"), value: 'WORKITEM_ABORTED' },
        { text: this.localePipe.transform("component.activityComponent.WORKITEM_RETRIEVED"), value: 'WORKITEM_RETRIEVED' },
        { text: this.localePipe.transform("component.activityComponent.WORKITEM_CLAIMED"), value: 'WORKITEM_CLAIMED' },
        { text: this.localePipe.transform("component.activityComponent.WORKITEM_UNCLAIMED"), value: 'WORKITEM_UNCLAIMED' },
        { text: this.localePipe.transform("component.activityComponent.ACTIVITY_ASSIGNMENT"), value: 'ACTIVITY_ASSIGNMENT' }
    ];
}
